import { useEffect, useState } from "react";
import { candidateApi } from "@/lib/candidateApi";
import { applyBranding } from "@/lib/branding";
import type { InviteData } from "@/lib/types";

// Loads invite landing data and applies the agency's white-label branding before
// first interaction (the branding block is embedded in the invite response, so no
// second request and no unbranded flash for the rest of the journey).
export function useInvite(token: string | undefined) {
  const [data, setData] = useState<InviteData | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!token) {
      setError("This invite link is not valid.");
      setLoading(false);
      return;
    }
    let live = true;
    setLoading(true);
    candidateApi.getInvite(token).then((res) => {
      if (!live) return;
      if (res.ok) {
        applyBranding(res.branding);
        setData(res);
        setError(null);
      } else {
        setError(res.error);
      }
      setLoading(false);
    });
    return () => {
      live = false;
    };
  }, [token]);

  return { data, error, loading };
}
